import { COLORS } from '@avalara/bat-apps-shared/constants';
import styled from 'styled-components';

import { breakpoints } from '../../lib/constants';
import { FlexContainerRow } from './skylab/page';

const setBgColor = (props: { dark?: boolean }) => (props.dark ? '0' : '255');

export const NoClickContainer = styled.div<{ dark?: boolean; setOpactiy?: number }>`
  background-color: rgba(${setBgColor}, ${setBgColor}, ${setBgColor}, .7);
  filter: alpha(opactiy=${(props) => props.setOpactiy || '95'});
  height: 150%;
  left: 0;
  opacity: ${(props) => `.${props.setOpactiy}` || '.95'};
  position: fixed;
  top: 0;
  width: 150%;
  z-index: 9000;
`;

export const SystemErrorContainer = styled.div`
  height: 50%;
  left: 50%;
  min-width: 320px;
  max-width: 420px;
  position: fixed;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 50%;
  z-index: 9001;

  @media (max-width:${breakpoints.phone}px) {
    top: 35%;
    height: 30%;
  }
`;

export const MessageContainer = styled(FlexContainerRow)`
  align-items: center;
  background: #FFF;
  border: 1px solid ${COLORS.lightGray};
  display: flex;
  flex-direction: row;
  padding: 30px;
  position: relative;
  width: 100%;

  @media (max-width:${breakpoints.phone}px) {
    width: 80%;
  }

  div {
    text-align: center;
  }

  > *:last-child {
    position: unset;
  }

  > + * {
    width: 50%;
  }
`;

export const Message = styled.p`
  margin-top: .714em;
  margin-bottom: .9rem;
`;

export const CloseButton = styled.button`
  background: transparent;
  border: none;
  color: ${COLORS.darkBlue};
  position: absolute;
  top: 0;
  right: 0;
  padding: 5px 10px 10px;
  &:hover {
    cursor: pointer;
  }
`;
